import heroBg from './hero-bg.jpg';
import lifestyleBg from './lifestyle-bg.jpg';
import weavingCloseup from './weaving-closeup.jpg';
import fabricColorful from './fabric-colorful.jpg';
import fabricTexture from './fabric-texture.jpg';
import threadSpools from './thread-spools.jpg';
import schoolUniforms from './school-uniforms.jpg';
import silkFabric from './silk-fabric.jpg';
import textileRoll from './textile-roll.jpg';

export const uiImages = {
    heroBg,
    lifestyleBg,
    weavingCloseup,
    fabricColorful,
    fabricTexture,
    threadSpools,
    schoolUniforms,
    silkFabric,
    textileRoll,
};
